import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, useMediaQuery } from '@mui/material';
import Tabs, { tabsClasses } from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { useTheme } from '@mui/material/styles';

const TabsContainer = ({ pages }) => {
    const [value, setValue] = useState(0);
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));


    console.log(window.innerWidth);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Box sx={{ flexGrow: 1, maxWidth: isSmallScreen?"90vw":"90vw", bgcolor: 'background.paper' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    variant="scrollable"
                    scrollButtons
                    allowScrollButtonsMobile
                    aria-label="icon tabs"
                >
                    {pages.map((page, index) => (
                        <Tab
                            key={index}
                            icon={React.cloneElement(page.icon, {
                                color: value === index ? 'secondary' : 'inherit',
                            })}
                            label={page.title}
                            disabled={page.disabled}
                            sx={{
                                color: value === index ? theme.palette.primary.main : 'inherit',
                            }}
                        />
                    ))}
                </Tabs>
            </Box>
            <Box>
                {pages.map((page, index) => (
                    <Box
                        key={index}
                        role="tabpanel"
                        hidden={value !== index}
                        id={`tabpanel-${index}`}
                        aria-labelledby={`tab-${index}`}
                    >
                        {value === index && page.component }
                    </Box>
                ))}
            </Box>
        </Box>
    );
};

TabsContainer.propTypes = {
    pages: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string.isRequired,
            icon: PropTypes.element.isRequired,
            component: PropTypes.element.isRequired,
            disabled: PropTypes.bool,
        })
    ).isRequired,
};

export default TabsContainer;